// src/components/Steps.jsx
import { useEffect, useRef } from 'react';
import { useGsapContext } from '../hooks/useGsapContext';
import { gsap, ScrollTrigger } from '../lib/gsap/setupGsap';

export default function Steps() {
  const rootRef = useRef(null);
  const { ctx } = useGsapContext();

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;

    const art   = el.querySelector('.legion__art');                  // imagen del camper
    const list  = el.querySelectorAll('.steps__content ol li');      // ítems 1-2-3
    const strongs = el.querySelectorAll('.steps__content ol li strong'); // sub-reveal sutil

    ctx.current.add(() => {
      // Estados iniciales (por si el CSS no los define)
      if (art) gsap.set(art, { opacity: 0, y: 12, scale: 0.98 });
      list.forEach(li => gsap.set(li, { opacity: 0, y: 12, scale: 0.992, filter: 'blur(2px)' }));
      strongs.forEach(st => gsap.set(st, { opacity: 0.0 }));

      // Camper lateral
      if (art) {
        gsap.fromTo(
          art,
          { opacity: 0, y: 12, scale: 0.98 },
          {
            opacity: 1, y: 0, scale: 1,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: el,
              start: 'top 85%',
              end:   'top 60%',
              scrub: 0.4,
              invalidateOnRefresh: true,
              // markers: true,
            },
            immediateRender: false,
          }
        );
      }

      // Ítems (cada uno con su propio trigger)
      list.forEach((li) => {
        const st = li.querySelector('strong');

        gsap.fromTo(
          li,
          { opacity: 0, y: 12, scale: 0.992, filter: 'blur(2px)' },
          {
            opacity: 1, y: 0, scale: 1, filter: 'blur(0px)',
            ease: 'power2.out',
            scrollTrigger: {
              trigger: li,
              start: 'top 85%',
              end:   'top 70%',
              scrub: 0.35,
              invalidateOnRefresh: true,
            },
            immediateRender: false,
          }
        );

        if (st) {
          gsap.fromTo(
            st,
            { opacity: 0 },
            {
              opacity: 1,
              ease: 'power1.out',
              scrollTrigger: {
                trigger: li,
                start: 'top 80%',
                end:   'top 68%',
                scrub: 0.3,
                invalidateOnRefresh: true,
              },
              immediateRender: false,
            }
          );
        }
      });

      ScrollTrigger.refresh();
    });
  }, [ctx]);

  return (
    <section ref={rootRef} id="steps" className="steps" aria-label="Steps Outlander">
      <div className="steps__content">
        <h2>Tu aventura<br />comienza hoy</h2>
        <ol>
          <li>
            <strong>1. Agendá tu test drive:</strong>  viví una experiencia real off-road.
          </li>
          <li>
            <strong>2. Personalizá tu M85: </strong>elegí tus colores y tapizados y grabá tu frase personal.
          </li>
          <li>
            <strong>3. Unite a la Legión: </strong> recibí tu código de socio exclusivo y comenzá a explorar.
          </li>
        </ol>
      </div>
      <div className="legion__art" aria-hidden="true" />
    </section>
  );
}
